import { type RefObject, useRef } from "react"
import { Typography } from "@callcenter/design-system"
import cn from "clsx"
import { useUnit } from "effector-react"
import { useCustomOnClickOutside } from "@callcenter/hooks"

import { useMenuItems } from "../../shared/hooks"
import { isMenuItemActive } from "../../shared/helpers"
import { mobileNavigationModel } from "../../models"

import styles from "./navigation-mobile.module.pcss"
import sharedStyles from "../../shared/styles.module.pcss"

type NavigationMobileProps = {
  headerRef: RefObject<HTMLElement | null>
}

export const NavigationMobile = ({ headerRef }: NavigationMobileProps) => {
  const isOpen = useUnit(mobileNavigationModel.$isOpen)
  const menuItems = useMenuItems()
  const actions = useUnit({ close: mobileNavigationModel.close })
  const menuRef = useRef<HTMLDivElement>(null)
  const headerHeight = headerRef.current?.offsetHeight ?? 0

  useCustomOnClickOutside(
    menuRef,
    () => {
      if (isOpen) {
        actions.close()
      }
    },
    "data-click-target-header-exclude"
  )

  if (!isOpen) {
    return null
  }

  return (
    <div
      className={styles.mobileMenuDropdown}
      ref={menuRef}
      style={{ top: headerHeight, maxHeight: `calc(100dvh - ${headerHeight}px)` }}
    >
      {menuItems.map((item) => (
        <div className={styles.mobileDropdownGroup} key={item.key}>
          <Typography.Body2 className={cn(styles.mobileDropdownGroupHeader, sharedStyles.menuGroupLabel)}>
            {item.icon}
            {item.label}
          </Typography.Body2>
          {item.children.map((menuItem) => (
            <Typography.TopHeader
              as="a"
              href={menuItem.path}
              key={menuItem.path}
              className={cn(sharedStyles.menuItem, { [sharedStyles.active]: isMenuItemActive(menuItem) })}
            >
              {menuItem.label}
              {menuItem.badge}
            </Typography.TopHeader>
          ))}
        </div>
      ))}
    </div>
  )
}
